'use client';

import { c as _c } from "react/compiler-runtime";
import { assignInlineVars } from '@vanilla-extract/dynamic';
import { anchorName, flyoutAnchor, flyoutPopover, headerMetaSharesheetButton } from './sharesheet.css';
import { Dispatch, ReactNode, SetStateAction, useCallback, useId, useRef, useState } from 'react';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { secondaryButtonBox } from '@/uiComposites/interactive/callToAction';
import { box } from '@/uiPrimitives/layout/box';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { textBlock, textStyle } from '@/uiPrimitives/typography/text';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { icon, IconProps } from '@/uiPrimitives/media/icon';
import { shareIcon } from '@/uiIcons/shareIcon.css';
import { stack } from '@/uiPrimitives/layout/stack';
import { IconLinkContent } from '@/uiComposites/interactive/IconLink';
import { emailIcon } from '@/uiIcons/emailIcon.css';
import { translateInline } from '@/globals/translate/translateInline';
import { placement } from '@/uiPrimitives/layout/placement.css';
import { copyLinkIcon } from '@/uiIcons/copyLinkIcon.css';
import { onInteractOutsideOfRef } from '@/globals/helpers/useInteractOutside';
import { position } from '@/uiPrimitives/layout/position';
import { sharesheetButtonTranslations, sharesheetStatusTranslations } from './sharesheetTranslations';
import { pushShareResultsExpandEvent, pushShareResultsClickEvent } from '@/globals/analytics/events/pushDecisionToolEvent';
import { addTestSelector, testSelectorAttribute } from '@/globals/testHelpers/testSelector';
import { unprintable } from '@/uiPrimitives/base/printable.css';
import { printerIcon } from '@/uiIcons/printerIcon.css';
import { hiddenAccessible, hiddenAccessibleBelowMQ640px } from '@/uiPrimitives/utility/display.css';
import { checkIcon } from '@/uiIcons/checkIcon.css';
import { warningIcon } from '@/uiIcons/warningIcon.css';
const Flyout = t0 => {
  const $ = _c(46);
  const {
    id,
    buttonSlot,
    pageTitle,
    setShareState
  } = t0;
  const flyoutRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (flyoutRef.current == null) {
        return;
      }
      flyoutRef.current.hidePopover();
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeFlyout = t1;
  const t2 = `--flyout-${id}`;
  let t3;
  if ($[1] !== t2) {
    t3 = assignInlineVars({
      [anchorName]: t2
    });
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = {
      ...t3
    };
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = classes(box({
      inlineSize: "fit-content"
    }), position({
      position: "relative"
    }));
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = classes(flyoutPopover, textStyle({
      capSize: "0 | p"
    }));
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = classes(box({
      padding: "1 | h3",
      borderRadius: "4px"
    }));
    t8 = classes(stack({
      rowGap: "3 | h1"
    }));
    t9 = classes(box({}));
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== setShareState) {
    t10 = async () => {
      pushShareResultsClickEvent({
        label: translateInline({
          en: "Copy link",
          nl: "Kopieer link"
        })
      });
      closeFlyout();
      setShareState("idle");
      ;
      try {
        await navigator.clipboard.writeText(window.location.href);
        setShareState("copySuccess");
      } catch (t11) {
        setShareState("copyError");
      }
    };
    $[10] = setShareState;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <IconLinkContent icon={<i className={classes(icon({
      icon: copyLinkIcon,
      blockSize: "2 | h2"
    }), placement({
      justifySelf: "center"
    }))} />}>{translateInline({
        en: "Copy link",
        nl: "Kopieer link"
      })}</IconLinkContent>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t10) {
    t12 = <li><button className={t9} onClick={t10}>{t11}</button></li>;
    $[13] = t10;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== pageTitle || $[16] !== setShareState) {
    t13 = () => {
      pushShareResultsClickEvent({
        label: translateInline({
          en: "Share (email)",
          nl: "Deel via e-mail"
        })
      });
      closeFlyout();
      setShareState("emailTried");
      window.location.href = `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(`${pageTitle}: ${window.location.href}`)}`;
    };
    $[15] = pageTitle;
    $[16] = setShareState;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = classes(box({}));
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconLinkContent icon={<i className={classes(icon({
      icon: emailIcon,
      blockSize: "0 | p"
    }), placement({
      justifySelf: "center"
    }))} />}>{translateInline({
        en: "Share (email)",
        nl: "Deel via e-mail"
      })}</IconLinkContent>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t13) {
    t16 = <li><button onClick={t13} className={t14}>{t15}</button></li>;
    $[20] = t13;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] !== setShareState) {
    t17 = () => {
      pushShareResultsClickEvent({
        label: translateInline({
          en: "Print",
          nl: "Printen"
        })
      });
      closeFlyout();
      setShareState("idle");
      window.print();
    };
    $[22] = setShareState;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = classes(box({}));
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <IconLinkContent icon={<i className={classes(icon({
      icon: printerIcon,
      blockSize: "1 | h3"
    }), placement({
      justifySelf: "center"
    }))} />}>{translateInline({
        en: "Print",
        nl: "Printen"
      })}</IconLinkContent>;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] !== t17) {
    t20 = <li><button onClick={t17} className={t18}>{t19}</button></li>;
    $[26] = t17;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = classes(box({}));
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  let t22;
  if ($[29] !== setShareState) {
    t22 = async () => {
      pushShareResultsClickEvent({
        label: translateInline({
          en: "Share (other)",
          nl: "Meer deelopties"
        })
      });
      closeFlyout();
      setShareState("idle");
      if (await openNativeSharesheet()) {
        setShareState("idle");
      } else {
        setShareState("shareSheetError");
      }
    };
    $[29] = setShareState;
    $[30] = t22;
  } else {
    t22 = $[30];
  }
  let t23;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <IconLinkContent icon={<i className={classes(icon({
      icon: shareIcon,
      blockSize: "1 | h3"
    }), placement({
      justifySelf: "center"
    }))} />}>{translateInline({
        en: "Share (other)",
        nl: "Meer deelopties"
      })}</IconLinkContent>;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== t22) {
    t24 = <li><button className={t21} onClick={t22}>{t23}</button></li>;
    $[32] = t22;
    $[33] = t24;
  } else {
    t24 = $[33];
  }
  let t25;
  if ($[34] !== t12 || $[35] !== t16 || $[36] !== t20 || $[37] !== t24) {
    t25 = <div tabIndex={-1} className={t7}><ul className={t8}>{t12}{t16}{t20}{t24}</ul></div>;
    $[34] = t12;
    $[35] = t16;
    $[36] = t20;
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== id || $[40] !== t25) {
    t26 = <div className={t6} id={id} popover="auto" ref={flyoutRef}>{t25}</div>;
    $[39] = id;
    $[40] = t25;
    $[41] = t26;
  } else {
    t26 = $[41];
  }
  let t27;
  if ($[42] !== buttonSlot || $[43] !== t26 || $[44] !== t4) {
    t27 = <div style={t4} className={t5}>{buttonSlot}{t26}</div>;
    $[42] = buttonSlot;
    $[43] = t26;
    $[44] = t4;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  return t27;
};
const isMobile = () => {
  if (!('userAgentData' in navigator)) return false;

  // @ts-expect-error - userAgentData is a new DOM api
  return navigator.userAgentData.mobile;
};
const shouldUsePopupSharesheet = () => {
  return !isMobile() && Object.hasOwn(HTMLElement.prototype, 'popover');
};
const ShareButton = ({
  id,
  shareState,
  setShareState,
  buttonLabel,
  className,
  iconSize,
  [testSelectorAttribute]: dataUITest = 'uiSharesheetButton'
}: {
  id: string;
  shareState: ShareSheetStatus;
  setShareState: Dispatch<SetStateAction<ShareSheetStatus>>;
  buttonLabel: ReactNode;
  className?: string;
  iconSize?: IconProps['blockSize'];
  [testSelectorAttribute]?: string;
}) => {
  let statusText = '';
  switch (shareState) {
    case 'copySuccess':
      statusText = sharesheetStatusTranslations['Link copied'];
      break;
    case 'emailTried':
      statusText = sharesheetStatusTranslations['We’re trying to open your email program'];
      break;
    case 'copyError':
      statusText = sharesheetStatusTranslations['Cannot copy link'];
      break;
    case 'shareSheetError':
      statusText = sharesheetStatusTranslations['Cannot open share options'];
      break;
    default:
      break;
  }
  const isSuccessfulState = shareState === 'copySuccess' || shareState === 'emailTried';
  return <button popoverTarget={id} onClick={async event => {
    setShareState('idle');
    if (shouldUsePopupSharesheet()) {
      const popoverElement = document.getElementById(id);
      if (popoverElement?.matches(':popover-open') === false) {
        pushShareResultsExpandEvent();
      }
      return;
    }
    pushShareResultsExpandEvent();
    event.preventDefault();
    if (await openNativeSharesheet()) {
      setShareState('idle');
    } else {
      setShareState('shareSheetError');
    }
  }} className={className} {...addTestSelector(dataUITest)}>
			<span className={classes(occupy({
      blockSize: 'capSize',
      inlineSize: iconSize
    }))}>
				<i className={classes(flyoutAnchor, shareState !== 'idle' && hiddenAccessible, icon({
        icon: shareIcon,
        blockSize: iconSize
      }))}></i>
				<i role="status" title={statusText} tabIndex={-1} ref={onInteractOutsideOfRef(() => {
        setShareState('idle');
      })} className={classes(shareState === 'idle' && hiddenAccessible, icon({
        icon: isSuccessfulState ? checkIcon : warningIcon,
        fill: isSuccessfulState ? 'positiveGreen' : 'positiveOrange',
        blockSize: iconSize
      }))}></i>
			</span>
			<span className={classes(textBlock({}))}>{buttonLabel}</span>
		</button>;
};
type ShareSheetStatus = 'idle' | 'copyError' | 'copySuccess' | 'shareSheetError' | 'emailTried';
export const Sharesheet = ({
  buttonLabel,
  pageTitle,
  className,
  buttonClassName = classes(secondaryButtonBox({}), shelf({
    columnGap: '1 | h3'
  })),
  buttonIconSize = '1 | h3',
  [testSelectorAttribute]: dataUITest
}: {
  buttonLabel: ReactNode;
  pageTitle: string;
  className?: string;
  buttonClassName?: string;
  buttonIconSize?: IconProps['blockSize'];
  [testSelectorAttribute]?: string;
}) => {
  const id = useId();
  // Sharesheet success does not have it's own state
  // because the native sharesheet appearing is enough feedback
  // Email sucess or error is not handled either,
  // because the user is redirected to their email client.
  const [shareState, setShareState] = useState<ShareSheetStatus>('idle');
  return <div className={classes(box({
    inlineSize: 'fit-content'
  }), unprintable, className)}>
			<Flyout id={id} setShareState={setShareState} pageTitle={pageTitle} buttonSlot={<ShareButton id={id} shareState={shareState} setShareState={setShareState} buttonLabel={buttonLabel} className={buttonClassName} iconSize={buttonIconSize} {...addTestSelector(dataUITest)} />} />
		</div>;
};

/* This will show the small share-sheet button in the header-meta bar */
export const HeaderMetaSharesheet = t0 => {
  const $ = _c(6);
  const {
    pageTitle
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className={hiddenAccessibleBelowMQ640px}>{sharesheetButtonTranslations.Share}</span>;
    t2 = classes(shelf({
      gap: {
        min640px: "-2 | smaller",
        max640px: "0px"
      }
    }), textStyle({
      color: "positiveBlue"
    }), headerMetaSharesheetButton);
    t3 = {
      max640px: "2 | h2",
      min640px: "1 | h3"
    };
    t4 = addTestSelector("uiSharesheetHeaderButton");
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== pageTitle) {
    t5 = <Sharesheet pageTitle={pageTitle} buttonLabel={t1} buttonClassName={t2} buttonIconSize={t3} {...t4} />;
    $[4] = pageTitle;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
async function openNativeSharesheet() {
  if (!('share' in navigator)) return false;
  try {
    await navigator.share({
      url: window.location.href
    });
    return true;
  } catch (error) {
    if (error instanceof DOMException && error.name === 'AbortError') {
      return true;
    }
    return false;
  }
}